import { Injectable } from '@angular/core';
import { UrlTree } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { FeatureFlagService } from '@amfam/shared/utility/feature-flag/data-access';
import { fromRouterActions } from '@amfam/shared/utility/navigation';

@Injectable({
  providedIn: 'root'
})
export class BillAccountContactGuard {
  constructor(
    private featureFlagService: FeatureFlagService,
    private store: Store
  ) {}
  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.featureFlagService.isEnabled('contact_billing')) {
      return true;
    } else {
      this.store.dispatch(
        fromRouterActions.Go({
          path: ['/overview']
        })
      );
      return false;
    }
  }
}
